// Normalizes DRF pagination `next` links (which may be absolute) into a relative
// path that can be safely passed to an axios instance configured with
// `baseURL: http://.../api/`.
//
// Examples:
// - https://localhost:8000/api/tasks/?page=2 -> tasks/?page=2
// - http://localhost:8000/api/documents/?page=3 -> documents/?page=3
// - /api/clients/?page=2 -> clients/?page=2
// - clients/?page=2 -> clients/?page=2
export function normalizeApiNextUrl(nextUrl) {
  if (!nextUrl) return nextUrl;

  // Handle absolute URLs.
  if (nextUrl.startsWith('http://') || nextUrl.startsWith('https://')) {
    if (
      process.env.NODE_ENV !== 'production' &&
      nextUrl.startsWith('https://') &&
      (nextUrl.includes('127.0.0.1') || nextUrl.includes('localhost'))
    ) {
      // Helps identify where https next links are coming from in local dev.
      // eslint-disable-next-line no-console
      console.warn('[api] Normalizing absolute https pagination URL:', nextUrl);
    }
    try {
      const parsed = new URL(nextUrl);
      return normalizeApiNextUrl(`${parsed.pathname || ''}${parsed.search || ''}`);
    } catch (_) {
      // Fall through and attempt string-based normalization.
    }
  }

  const apiMarker = '/api/';
  const apiIndex = nextUrl.indexOf(apiMarker);
  if (apiIndex !== -1) {
    return nextUrl.slice(apiIndex + apiMarker.length);
  }

  // Common variant: "api/..." (without leading slash)
  if (nextUrl.startsWith('api/')) {
    return nextUrl.slice('api/'.length);
  }

  // If it's just a leading slash (e.g. "/tasks/?page=2"), make it relative.
  if (nextUrl.startsWith('/')) {
    return nextUrl.replace(/^\/+/, '');
  }

  return nextUrl;
}
